import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { StorageTypeModel } from '../../../../../shared/entities/storage-space.model';
import { StorageTypeService } from '../../../../../shared/services/app/storage-type.service';

@Component({
    selector: 'app-storage-type-add-edit',
    templateUrl: './storage-type-add-edit.component.html',
    styleUrls: ['./storage-type-add-edit.component.scss']
})
export class StorageTypeAddEditComponent implements OnInit {

    public uid: string = null;
    public storageTypeModel: StorageTypeModel = new StorageTypeModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private storageTypeService: StorageTypeService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

        return;
    }

    onCloseDialog(storageType: StorageTypeModel) {
        this.ref.close(storageType);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.storageTypeModel.uid],
            name: [this.storageTypeModel.name, [Validators.required, Validators.maxLength(255)]],
        });
    }

    getItem(): void {
        this.loading = true;
        this.storageTypeService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.storageTypeModel.map(response.payload);
                this.form.patchValue(this.storageTypeModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.storageTypeService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.storageTypeModel.map(response.payload);
                this.form.patchValue(this.storageTypeModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Tipul de Stocare a fost salvat cu success!'
                });
                this.ref.close(this.storageTypeModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {

                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }

}
